import styled, { css } from 'styled-components';

import { gutter, margin, breakpoint, mediaQuery, SIZE, SIZES, maxWidth, pixelate } from './metrics';

export const gridAtSize = (size) => `
	padding-left: ${margin(size)};
	padding-right: ${margin(size)};
`;

export const grid = () => {
	let styles = ``;

	SIZES.forEach(size => {
		if(size === SIZE.small){
			styles += gridAtSize(size);
		}
		else{
			styles += `${mediaQuery[size]}{
				${gridAtSize(size)}
			}`
		}
	});

	return styles;
};

export const rowAtSize = (size, {reverse=false,wrap=true}) => `
	display: flex;
	margin-left: ${gutter(size,{multiplier:-0.5})};
	margin-right: ${gutter(size,{multiplier:-0.5})};
	flex-wrap: ${!!wrap ? `wrap` : `no-wrap`};
	flex-direction: ${!!reverse ? `row-reverse` : `row`};
`;

const round = (num) => {
	return Math.floor( num * 10000 ) / 10000
}

export const row = (sizes={}, {reverse=false,wrap=true}={}) => {
	let styles = ``;
	let props = null;

	SIZES.forEach(size => {
		props = sizes[size] ? {...props,...sizes[size]} : props;

		if(props){
			if(size === SIZE.small){
				styles += rowAtSize(size,props);
			}
			else{
				styles += `${mediaQuery[size]}{
					${rowAtSize(size,props)}
				}`
			}
		}
	});

	return styles;
};

export const columnAtSize = (size, {span,before=0,after=0,total=12,reverse=false}, {direction="ltr"}) => {
	let left = 0;
	let right = 0;

	if(direction === "rtl"){
		right = reverse ? after : before;
		left = reverse ? before : after;
	}
	else{
		left = reverse ? after : before;
		right = reverse ? before : after;
	}

	return `
		padding-left: ${gutter(size,{multiplier:0.5})};
		padding-right: ${gutter(size,{multiplier:0.5})};
		margin-left: ${left ? `calc((100% * ${round(1 / total)}) * ${left});` : `0;`}
		margin-right: ${right ? `calc((100% * ${round(1 / total)}) * ${right});` : `0;`}
		width: calc((100% * ${round(1 / total)}) * ${span ? span : total});
		flex: 0 0 calc((100% * ${round(1 / total)}) * ${span ? span : total});
	`;
}


export const column = (sizes={}, {direction="ltr"}={}) => {
	let styles = ``;
	let props = null;
	

	SIZES.forEach(size => {
		props = sizes[size] ? {...props,...sizes[size]} : props;

		if(props){
			if(size === SIZE.small){
				styles += columnAtSize(size,props,{direction});
			}
			else{
				styles += `${mediaQuery[size]}{
					${columnAtSize(size,props,{direction})}
				}`
			}
		}
	});

	return styles;
}

export const imageAtSize = (size, {span,total=12,margins=0,gutters=0}) => {
	return `calc((((${size === SIZE.max ? maxWidth() : `100vw`} - ${margin(size,{multiplier:2})}) * ${round(1 / total)}) * ${span ? span : total}) - ${gutter(size)} ${margins > 0 && gutters > 0 ? ` + ${pixelate(margin(size,{pixelate:false,multiplier:margins}) + gutter(size,{pixelate:false,multiplier:gutters}))}` : ''})`;
}

export const getImageSizes = (sizes={},{defaultSize="100vw"}={defaultSize:"100vw"}) => {
	let props = null;
	let result = defaultSize;
	let imageSize;

	SIZES.forEach(size => {
		props = sizes[size] ? {...props,...sizes[size]} : props;
		if(props){
			imageSize = imageAtSize(size,props);
			result = `(min-width: ${breakpoint(size)}) ${imageSize}, ${result}`;
		}
		
	});

	return result;

}
